import { render, staticRenderFns } from "./rightmenu.vue?vue&type=template&id=7350ce5c&scoped=true"
import script from "./rightmenu.vue?vue&type=script&lang=js"
export * from "./rightmenu.vue?vue&type=script&lang=js"
import style0 from "./rightmenu.vue?vue&type=style&index=0&id=7350ce5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7350ce5c",
  null
  
)

export default component.exports